import React, {useEffect, useState} from 'react';
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import {Modal, ModalBody, Row, Col, ButtonToolbar, Button, ModalHeader, Card, CardBody} from 'reactstrap';
import { Form, Field } from 'react-final-form';
import renderSelectField from '@/shared/components/form/Select'
import CheckboxField from "@/shared/components/form/CheckboxField";
import axios from "axios";
import { getProgramAction } from '@/redux/actions/programActions';
import CloseButton from "@/shared/components/CloseButton";
import { Table} from 'antd';

const DomainsModal = ({isOpen, toggle, program, theme, rtl}) => {
  const dispatch = useDispatch()
  const [errors, setErrors] = useState(null);
  const [domainOptions, setDomainOptions] = useState(null);
  const [defaultDomain, setDefaultDomain] = useState(null);
  const [isOpenHierarchy, setOpenHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [hierarchyListData, setHierarchyListData] = useState([]);
  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [formValues, setFormValues] = useState([]);

  const [loading, setLoading] = useState(false);

  const modalProps = {
        isOpen, toggle
    }
  useEffect(() => {
    if (!defaultDomain) {
        const domainSource =
        program?.default_domain?.length > 0
            ? program.default_domain[0]
            : program?.domains?.[0];

        if (domainSource) {
        setDefaultDomain({
            label: domainSource.name,
            value: domainSource.id,
        });
        }
    }

    if (!domainOptions) {
        let options = [];
        program?.domains?.forEach((domain) => {
        options.push({ label: domain.name, value: '' + domain.id });
        });
        setDomainOptions(options);
    }
    }, [program]);

  const onChangeDefaultDomain = (value) => {
    setDefaultDomain(value);
  }
  const onSubmit = async (values) => {
    const url = `/organization/${program.organization_id}/program/${program.id}/default-domain`
    try {
      const response = await axios.post(url, { default_domain:  defaultDomain?.value });
      if (response.status === 200) {
        dispatch(getProgramAction(program.organization_id,program.id))
        dispatch(sendFlashMessage('Default domain added successfully!', 'alert-success'))
        toggle();
      }
    }
    catch (err) {
      setErrors(err.response.data);
    }
    finally {
      setLoading(false);
    }
  };

  const onCustomDomainSubmit = (values) => {
    setFormValues(values)
    toggleHierarchy();
  }

  const toggleHierarchy = (values) => {
    setOpenHierarchy(prevState => !prevState)
  }

  const toggleHierarchyList = () => {
    setOpenHierarchyList(prevState => !prevState)
  }

    const toggleHierarchyResult = () => {
    setOpenHierarchyResult(prevState => !prevState)
  }

  const onSubmitHierarchy = () => {
    axios
      .get(`/organization/${program.organization_id}/program/${program.id}/hierarchy-prepare-list`)
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListData(res.data);
          dispatch(sendFlashMessage('Custom domain added successfully!', 'alert-success'))
          toggleHierarchy();
          const tmpCheckedState = [];
          res.data.map(item => {
            tmpCheckedState.push({ checked: true, value: item.id });
          });
          setCheckedState(tmpCheckedState);
          toggleHierarchyList();
        }
      })
      .catch((err) => {
        dispatch(sendFlashMessage(JSON.stringify(err.response.data), 'alert-danger'))
        setLoading(false);
        toggleHierarchy();
      });
  };

  const onSubmitHierarchyList = () => {
    const payload = {
      from_email_name: formValues.from_email_name,
      from_email_domain: formValues.from_email_domain ?? formValues.custom_domain_name?.label
    }

    const programIds = [];
    checkedState.map(item => {
      if (item.checked) {
        programIds.push(item.value)
      }
    });
    payload.programIds = programIds;

    axios
      .put(`/organization/${program.organization_id}/program/${program.id}/update-hierarchy-list`, payload)
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListDataResult(res.data);
          toggleHierarchyList();
          toggleHierarchyResult();
        }
      })
      .catch((err) => {
        dispatch(sendFlashMessage(JSON.stringify(err.response.data), 'alert-danger'))
        setLoading(false);
        toggleHierarchyList();
      });
  };

  const columnsHierarchyList = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Update?',
      key: 'action',
      render: (_, record, index) => (
        <>
          <div className="checkbox-custom2">
            <CheckboxField
              name={`action-checkbox-${record.id}`}
              label={'update'}
              checked={checkedState[index].checked}
              disabled={checkedState[index].value === program.id ? true : false}
              onChange={(e) => {
                const tmpCheckedState = [...checkedState];
                tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
                setCheckedState(tmpCheckedState)
              }}
            />
          </div>
        </>
      ),
    },
  ];

  const columnsHierarchyResult = [
    {
      title: 'Program ID',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Program Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Result',
      dataIndex: 'result',
      key: 'result',
    },
  ];

  const onClickRemove = (id) => {
    if (!window.confirm("Are you sure to remove this program from this domain?")) {
      return;
    }
    setLoading(true);
    axios.delete(`/organization/${program.organization_id}/domain/${id}/program/${program.id}`)
      .then((res) => {
        if (res.status === 200) {
          dispatch(sendFlashMessage('Program removed from Domain!', 'alert-success', 'top'));
          dispatch(getProgramAction(program.organization_id, program.id));
        }
      })
      .catch(error => {
        setLoading(false)
        dispatch(sendFlashMessage(JSON.stringify(error.response.data), 'alert-danger', 'top'));
      })
  }    

  const onCustomSubmit = async (values) => {
    const custom_domain_url = `/organization/${program.organization_id}/program/${program.id}/custom-email-domain`
    try {
      if (formValues.from_email_name && (formValues.custom_domain_name || formValues.from_email_domain)) {
        const payload = {
          from_email_name: formValues.from_email_name,
          from_email_domain: formValues.from_email_domain ?? formValues.custom_domain_name?.label
        }
      const response = await axios.post(custom_domain_url, payload)
      if (response.status === 200) {
        dispatch(getProgramAction(program.organization_id, program.id))
        dispatch(sendFlashMessage('Domain added successfully!', 'alert-success'))
        toggle();
        toggleHierarchy();
      }
      }
    }
    catch (err) {
      setErrors(err.response.data);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <Modal className={`modal-program modal-lg ${theme.className} ${rtl.direction}-support`} {...modalProps}>
      <CloseButton onClick={toggle} />
      <ModalBody className='modal-lg pb-0'>
        <Card>
          <CardBody className='py-0'>
            <Row>
              <Col md="12" lg="12" xl="12">
                <div className="card__title">
                  <h3>Domain settings.</h3>
                  <h5 className="colorgrey">{program.name}</h5>
                </div>
                <hr/>
              </Col>
            </Row>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6" lg="6" xl="6">
                      {errors && <ApiErrorMessage className="alert alert-danger fade show w100" errors={errors} />}
                      <div style={{ float: 'left', padding: '5px 10px 0px 0px' }}>Default domain:</div>
                      <div style={{ float: 'left', minWidth: '250px' }}>
                        <Field
                          name="default_domain"
                          options={domainOptions}
                          initialValue={defaultDomain?.value}
                          component={renderSelectField}
                          parse={(value) => {
                            onChangeDefaultDomain(value);
                            return value;
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="6" lg="6" xl="6" className='text-right'>
                      <Button style={{ padding: '6px 25px' }}
                        type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">Save</Button>
                    </Col>
                  </Row>
                </form>
              )}
            />
            <Row>
              <Col md="12" lg="12" xl="12">
                {program.domains.length > 0 &&
                  program.domains.map((domain, i) => (
                    <div key={`domain-list-${i}`}>
                      <Link target="_blank" to={{ pathname: `http://${domain.name}${domain.port ? `:${domain.port}` : ''}` }}>{domain.name}{domain.port ? `:${domain.port}` : ''}</Link> →{' '}
                      <Link to={`/domains/view/${domain.id}`}>settings</Link> &nbsp; | &nbsp;
                      <Link to="#" onClick={() => onClickRemove(domain.id)} disabled={loading} className="text-danger">Remove </Link>
                    </div>
                  ))}
                <div style={{ paddingTop: '10px', clear: 'both', width: '100%' }}>&nbsp;</div>
                <hr />
              </Col>
            </Row>
            <Form
              onSubmit={onCustomDomainSubmit}
              initialValues={{
                from_email_name: program.from_email_name,
                custom_domain: false,
              }}
              render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form className="form" onSubmit={handleSubmit}>
                  {errors && <ApiErrorMessage className="alert alert-danger fade show w100" errors={errors} />}
                  <Row className=''>
                    <Col md="6" lg="6" xl="6">
                      <h5 className='thick size16'>Email Domain Setting</h5>
                    </Col>
                    <Col md="6" lg="6" xl="6" className='text-right'>
                      <Button style={{ padding: '6px 25px' }}
                        type="submit" disabled={ loading || !values.from_email_name || (!values.custom_domain_name && !values.from_email_domain) } className="btn btn-primary" color="#ffffff">Save</Button>
                    </Col>
                  </Row>
                  <Row className='w100'>
                    <Col md="6" lg="4" xl="4">
                      <Field name="from_email_name">
                        {({ input, meta }) => (
                          <div className="form__form-group">
                            <span className="form__form-group-label">from Email Name</span>
                            <div className="form__form-group-field">
                              <div className="form__form-group-row">
                                <input type="text" {...input} placeholder="From Email name" />
                                {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                              </div>
                            </div>
                          </div>
                        )}
                      </Field>
                    </Col>
                  </Row>
                  {!values.custom_domain &&
                    <div className="form__form-group">
                      <span className="form__form-group-label" >from Email Domain:</span>
                      <div className="form__form-group-field">
                        <Row>
                          <Col md="6" lg="4" xl="4">
                            <Field name="custom_domain_name">
                              {({ input, meta }) => (
                                <Field
                                  {...input}
                                  component={renderSelectField}
                                  options={domainOptions}
                                  placeholder={'Select domain...'}
                                />
                              )}
                            </Field>
                          </Col>
                          <Col md="6" lg="4" xl="4"><div><b>Selected Domain: </b>{program.from_email_domain}</div></Col>
                        </Row>
                      </div>
                    </div>}
                  <Row className='w100'>
                    <Col md="6" lg="4" xl="4">
                      <CheckboxField
                        name='custom_domain'
                        label="Custom Email Domain"
                        onChange={(event) => {
                          if (!event.target.checked) {
                            form.change('from_email_domain', undefined);
                          }
                        }}
                      />
                    </Col>
                  </Row>
                  {!!values.custom_domain &&
                    <Row className='w100'>
                      <Col md="6" lg="4" xl="4">
                        <Field name="from_email_domain">
                          {({ input, meta }) => (
                            <div className="form__form-group">
                              <span className="form__form-group-label">set Custom Domain</span>
                              <div className="form__form-group-field">
                                <div className="form__form-group-row">
                                  <input type="text" {...input} placeholder="From Email Domain" />
                                  {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                </div>
                              </div>
                            </div>
                          )}
                        </Field>
                      </Col>
                    </Row>
                  }
                </form>
              )}
            />
            {/* update hierarchy modal */}
            <Modal
              className={`modal-event-hierarchy modal-md`}
              isOpen={isOpenHierarchy}
              toggle={toggleHierarchy}
            >
              <ModalHeader>
                <div>
                  Would you like to save this across the entire program
                  hierarchy?
                </div>
              </ModalHeader>
              <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  onClick={onCustomSubmit}
                  color="#ffffff"
                >
                  No, only save to this program
                </Button>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  onClick={onSubmitHierarchy}
                  color="#ffffff"
                  style={{ float: "left" }}
                >
                  Yes, save to Hierarchy
                </Button>
                <Button
                  outline
                  color="primary"
                  className="btn btn-sm"
                  onClick={toggleHierarchy}
                  style={{ float: "right" }}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
            {/*  update modal end */}
            {/* list hierarchy modal */}
            <Modal
              className={`modal-event-hierarchy-list modal-lg`}
              isOpen={isOpenHierarchyList}
              toggle={toggleHierarchyList}
            >
              <ModalHeader>
                <div>
                  Please select the programs that you wish to update for custom doamin
                </div>
              </ModalHeader>
              <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
                <Form onSubmit={onSubmitHierarchyList}>
                  {({ handleSubmit, form, submitting, pristine, values }) => (
                    <>
                      <form className="form" onSubmit={handleSubmit}>
                        <div style={{ padding: "10px" }}>
                          <Button
                            outline
                            className="btn btn-primary btn-sm"
                            color="#ffffff"
                          >
                            Save
                          </Button>
                        </div>

                        <Table
                          pagination={false}
                          rowKey="id"
                          columns={columnsHierarchyList}
                          dataSource={hierarchyListData}
                        />
                      </form>
                    </>
                  )}
                </Form>
              </ModalBody>
            </Modal>
            {/* list hierarchy modal end */}

            {/* updated result hierarchy modal */}
            <Modal
              className={`modal-event-hierarchy-list modal-lg`}
              isOpen={isOpenHierarchyResult}
              toggle={toggleHierarchyResult}
            >
              <ModalHeader>
                <div></div>
              </ModalHeader>
              <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
                <Table
                  pagination={false}
                  rowKey="id"
                  columns={columnsHierarchyResult}
                  dataSource={hierarchyListDataResult}
                />
              </ModalBody>
            </Modal>
          </CardBody>
        </Card>
      </ModalBody>
  </Modal>
)}

DomainsModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  setOpen: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
  program: PropTypes.object.isRequired,
};

export default withRouter(connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization,
  program: state.program
}))(DomainsModal));
